import { Box, Chip, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import _ from 'lodash';
import { format } from 'd3';
import React from 'react';
import { onlyDateFormatter } from '../../../../../../utils';
import { useAuthContext } from '../../../../../../context';

const DetailedInfo: React.FC<any> = ({ inquiry }) => {
	const { user } = useAuthContext();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Stack spacing={isMobile ? '6px' : '40px'} direction={!isMobile ? 'row' : 'column'}>
			{isMobile && Boolean(inquiry.fields.InternalStatus) && (
				<Stack alignItems={'center'} direction={'row'}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						Status
					</Typography>
					<Box flex={isMobile ? 1 : undefined}>
						<Chip label={inquiry.fields.InternalStatus} variant={'filled'} color={'primary'} size={'small'} />
					</Box>
				</Stack>
			)}

			<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'}>
				<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
					Type
				</Typography>
				<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
					Inquiry
				</Typography>
				{inquiry.fields['Went Live'] && (
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						Ticket
					</Typography>
				)}
			</Stack>
			<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'}>
				<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
					Created at
				</Typography>
				<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
					{onlyDateFormatter(new Date(inquiry.fields['Created At']))}
				</Typography>
				{inquiry.fields['Went Live'] && (
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						{onlyDateFormatter(new Date(inquiry.fields['Went Live']))}
					</Typography>
				)}
			</Stack>
			<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'}>
				<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
					Action
				</Typography>
				<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
					{_.capitalize(inquiry.fields.Action ?? '')}
				</Typography>
				{inquiry.fields['Went Live'] && (
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						{_.capitalize(inquiry.fields.Action ?? '')}
					</Typography>
				)}
			</Stack>
			{user?.instie && (
				<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						Market Visibility
					</Typography>
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						{inquiry.fields['Market Visibility']}
					</Typography>
				</Stack>
			)}
			{user?.instie && Boolean(inquiry.fields['Valuation']) && (
				<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						Valuation
					</Typography>
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						{inquiry.fields['Valuation']}
					</Typography>
				</Stack>
			)}
			{Boolean(inquiry.fields.Shares) && (
				<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'} sx={{ alignItems: 'end' }}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						Shares
					</Typography>
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						{format(',')(inquiry.fields.Shares)}
					</Typography>
					{inquiry.fields['Went Live'] && (
						<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
							{inquiry.fields.QTY ? format(',')(inquiry.fields.QTY) : 'N/A'}
						</Typography>
					)}
				</Stack>
			)}
			{Boolean(inquiry.fields.PPS) && (
				<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'} sx={{ alignItems: 'end' }}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						Share price
					</Typography>
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						{format('$,.2f')(inquiry.fields.PPS)}
					</Typography>
					{inquiry.fields['Went Live'] && (
						<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
							{inquiry.fields.Price ? format('$,.2f')(inquiry.fields.Price) : 'N/A'}
						</Typography>
					)}
				</Stack>
			)}
			{user?.instie && inquiry.fields['Block Size Min'] && (
				<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'} sx={{ alignItems: 'end' }}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						Block size min
					</Typography>
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						{format('$,.2f')(inquiry.fields['Block Size Min'])}
					</Typography>
				</Stack>
			)}
			{user?.instie && inquiry.fields['Shares From'] && (
				<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'} sx={{ alignItems: 'end' }}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						Min Shares
					</Typography>
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						{format(',.0f')(inquiry.fields['Shares From'])}
					</Typography>
				</Stack>
			)}
			{user?.instie && inquiry.fields['Block Size'] && (
				<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'} sx={{ alignItems: 'end' }}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						Block size max
					</Typography>
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						{format('$,.2f')(inquiry.fields['Block Size'])}
					</Typography>
				</Stack>
			)}
			{user?.instie && inquiry.fields['Shares'] && (
				<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'} sx={{ alignItems: 'end' }}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						Max Shares
					</Typography>
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						{format(',.0f')(inquiry.fields['Shares'])}
					</Typography>
				</Stack>
			)}
			{!user.instie && Boolean(inquiry.fields['Block Size']) && (
				<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'} sx={{ alignItems: 'end' }}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						Block size
					</Typography>
					<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
						{format('$,.2f')(inquiry.fields['Block Size'])}
					</Typography>
					{inquiry.fields['Went Live'] && (
						<Typography variant={'body2'} sx={{ color: 'text.primary' }} flex={isMobile ? 1 : undefined}>
							{inquiry.fields['Block Size Ticket'] ? format('$,.2f')(inquiry.fields['Block Size Ticket']) : 'N/A'}
						</Typography>
					)}
				</Stack>
			)}
			{!user?.instie && inquiry.fields['Expiration'] && (
				<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'} sx={{ alignItems: 'end' }}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						Expiration
					</Typography>
					<Typography variant={'body2'} color="text.primary">
						&nbsp;
					</Typography>
					<Typography variant={'body2'} color="text.primary" flex={isMobile ? 1 : undefined}>
						{onlyDateFormatter(new Date(inquiry.fields['Expiration']))}
					</Typography>
				</Stack>
			)}
			{!user?.instie && inquiry.fields['ROFR Start'] && (
				<Stack spacing={'4px'} direction={isMobile ? 'row' : 'column'} sx={{ alignItems: 'end' }}>
					<Typography variant={'body2'} sx={{ color: 'text.secondary' }} flex={isMobile ? 1 : undefined}>
						ROFR End
					</Typography>
					<Typography variant={'body2'} color="text.primary">
						&nbsp;
					</Typography>
					<Typography variant={'body2'} color="text.primary" flex={isMobile ? 1 : undefined}>
						{onlyDateFormatter(
							new Date(
								new Date(inquiry.fields['ROFR Start']).setDate(new Date(inquiry.fields['ROFR Start']).getDate() + 30)
							)
						)}
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};

export default DetailedInfo;
